import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoadingDimensions,
  makeSelectDimensionsDrillDown,
  makeSelectDivisions,
  makeSelectShowDimensionBenchmark,
} from "./selectors"
import { getDimensionsWatcher } from "./actions"

import {
  searchItemInTree,
  searchTree,
  truncateText,
  validate,
} from "../../../utils/functions"
import { isModeInModuleBySlug, isAmbassadorActive } from "../../../utils/storage"
import { DISABLE, RESULT_BY_DIMENSION } from "../../../utils/constants"
import { Link } from "react-router-dom"
import { Spin } from "antd"
import { QuestionCircleFilled } from "@ant-design/icons"
import ResultByDimensionChart from "../../../Reports/components/ReChart/ResultByDimensionChart"
import PopoverImpact from "../../../Reports/components/PopoverImpact"

import "../../../Reports/components/EngagementMeasurement/components/WidgetResultByDimensionEngagement/index.less"

export function WidgetResultByDimensionEngagement(props) {
  const [dimensionParent, setDimensionParent] = useState(0)
  const [dataAux, setDataAux] = useState([])

  useEffect(() => {
    initGetData()
  }, [props.dimensions])

  useEffect(() => {
    setDataChart()
  }, [props.dimensionsDrillDown, dimensionParent])

  const initGetData = () => {
    const {
      idMeasure,
      getDimensions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
      dimensions,
    } = props

    if (!validate.exist(measureGeneral)) return
    if (!dimensions || !dimensions.data) return

    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      dimensions,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }

    getDimensions(params)
  }

  const setDataChart = () => {
    const { dimensionsDrillDown, measureGeneral } = props
    const dataResult = []
    let result = []
    if (dimensionParent === 0) {
      result = [...dimensionsDrillDown]
    } else {
      result = searchTree([...dimensionsDrillDown], dimensionParent)
    }
    result.map((row) => {
      if (row.engagement) {
        return
      }
      let newValue = row.value
      if (!row.anonymity_check.valid) {
        newValue = 100
      }
      let newName =
        row.name === "Resultado total"
          ? measureGeneral.metric_total_label
          : row.name
      dataResult.push({
        name: newName,
        impact: row.impact,
        name_sort: truncateText(newName, 15),
        id_dimension: row.id_dimension,
        id_dimension_parent: row.id_dimension_parent,
        id: row.id,
        id_parent: row.id_parent,
        value: newValue,
        value_visible: row.value_visible,
        childs: row.childs,
        recipients: row.recipients,
        employees: row.employees,
        prev_value: row.prev_value,
        benchmark_value: row.benchmark_value,
        color: row.color,
        anonymity_check: row.anonymity_check,
      })
    })
    setDataAux(dataResult)
  }

  const renderTitle = () => {
    const {
      idMeasure,
      idDivisionSelected,
      selectedSegment,
      measureGeneral,
    } = props
    const isRedirect = isModeInModuleBySlug(RESULT_BY_DIMENSION)

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""
    if (idDivisionSelected) {
      queryDivision = `&id_division=${idDivisionSelected}`
    }
    if (measureGeneral.segments && measureGeneral.segments.length > 1 && selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }
    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }

    const link = `/reports/measure/${idMeasure}/divisions/${idDivisionSelected ||
      "all"}/dimensions${queryParams}`
    return (
      <div className="WidgetResultByDimensionEngagement-container-chart-header-container">
        <div className="WidgetResultByDimensionEngagement-container-chart-header-container-title">
          Resultado por dimensión con impacto
          <PopoverImpact
            container={
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 4,
                  cursor: "pointer",
                }}
              />
            }
          />
        </div>
        <div className="WidgetResultByDimensionEngagement-container-chart-header-container-link">
          {isRedirect !== DISABLE && (
            <Link to={link}>
              {"Ir a análisis detallado >"}
            </Link>
          )}
        </div>
      </div>
    )
  }

  const getDataChildren = (data) => {
    if (
      validate.exist(data.childs) &&
      data.childs.length > 0 &&
      data.anonymity_check.valid
    ) {
      setDimensionParent(data.id)
    }
  }

  const getBackData = (idDimensionParent) => {
    const result = searchItemInTree(
      [...props.dimensionsDrillDown],
      idDimensionParent
    )
    setDimensionParent(result.id_parent)
  }

  const renderChart = () => {
    const { measureGeneral, showDimensionBenchmark, measureTotal } = props

    return (
      <ResultByDimensionChart
        data={dataAux}
        measureGeneral={measureGeneral}
        getDataChildren={getDataChildren}
        getBackData={getBackData}
        dimensionParent={dimensionParent}
        showDimensionBenchmark={showDimensionBenchmark}
        hideImpact={measureTotal.employees <= 20}
      />
    )
  }

  const renderContainer = () => {
    if (props.isLoadingDimensions) {
      return (
        <div className="WidgetResultByDimensionEngagement-container">
          <div className="WidgetResultByDimension-container-chart">
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="WidgetResultByDimensionEngagement-container">
        <div className="WidgetResultByDimensionEngagement-container-chart">
          <div className="WidgetResultByDimensionEngagement-container-chart-header">
            {renderTitle()}
          </div>
          <div className="WidgetResultByDimensionEngagement-container-chart-container">
            {renderChart()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="WidgetResultByDimensionEngagement">{renderContainer()}</div>
  )
}

WidgetResultByDimensionEngagement.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  history: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDimensions: PropTypes.bool,
  dimensionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getDimensions: PropTypes.func,
  showDimensionBenchmark: PropTypes.bool,
  selectedSegment: PropTypes.number,
  dimensions: PropTypes.object,
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensions: makeSelectIsLoadingDimensions(),
  dimensionsDrillDown: makeSelectDimensionsDrillDown(),
  divisions: makeSelectDivisions(),
  showDimensionBenchmark: makeSelectShowDimensionBenchmark(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetResultByDimensionEngagementV2",
  reducer,
})
const withSaga = injectSaga({
  key: "widgetResultByDimensionEngagementV2",
  saga,
})

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDimensionEngagement)
